module.exports = __webpack_public_path__ + "media/images/icons/club-bi-f66568cd9da55985e5bb33f8452909e5.svg";